import React from 'react';
import MessageBody from "./MessageBody";

export default () => {
  const header = "Thanks for letting us know!";
  const subHeader = "Sorry it isn't the right survey for you, but we have new surveys starting all the time so hopefully we will see you again soon";
  return <MessageBody subtext={subHeader} header={header} />;
}